// Traducciones de /enlaces (la bio de Bison). Los nombres propios (Bison, ChatGPT, Gemini, Claude,
// Perplexity, Cursor, VS Code, MCP, WhatsApp) se mantienen; cada entrada es [es, en, pt-BR].
// Las claves deben coincidir exacto con el texto, espacios finales incluidos.
export const enlacesMessages = Object.fromEntries(
  [
    ['Haz que la IA ', 'Make AI ', 'Faça a IA '],
    [
      'Medimos cómo ChatGPT, Gemini, Claude y Perplexity presentan tu marca en LatAm.',
      'We measure how ChatGPT, Gemini, Claude and Perplexity present your brand in LatAm.',
      'Medimos como ChatGPT, Gemini, Claude e Perplexity apresentam sua marca na LatAm.',
    ],
    ['Agendar una reunión', 'Book a meeting', 'Agendar uma reunião'],
    ['Reserva un horario con el equipo.', 'Pick a time with the team.', 'Reserve um horário com a equipe.'],
    ['Lo último', 'Latest', 'Novidade'],
    ['Artículo', 'Article', 'Artigo'],
    ['Ranking', 'Ranking', 'Ranking'],
    ['Rankings de visibilidad en IA', 'AI visibility rankings', 'Rankings de visibilidade em IA'],
    [
      'Qué marcas aparecen en ChatGPT, Gemini y Claude, cómo se comparan y cambian cada mes, por industria y país.',
      'Which brands show up in ChatGPT, Gemini and Claude, how they compare and change each month, by industry and country.',
      'Quais marcas aparecem no ChatGPT, Gemini e Claude, como se comparam e mudam a cada mês, por indústria e país.',
    ],
    ['Blog: cómo la IA elige marcas', 'Blog: how AI picks brands', 'Blog: como a IA escolhe marcas'],
    [
      'Artículos y datos propios sobre AEO: qué fuentes cita la IA, por qué elige unas marcas y cómo medir tu visibilidad.',
      'Articles and original data on AEO: which sources AI cites, why it picks some brands and how to measure your visibility.',
      'Artigos e dados próprios sobre AEO: quais fontes a IA cita, por que escolhe algumas marcas e como medir sua visibilidade.',
    ],
    ['Recibe el newsletter', 'Get the newsletter', 'Receba a newsletter'],
    [
      'Novedades de IA y búsqueda, rankings de tu país y eventos, sin spam.',
      'AI and search updates, your country’s rankings and events, no spam.',
      'Novidades de IA e busca, rankings do seu país e eventos, sem spam.',
    ],
    ['Escríbenos por WhatsApp', 'Message us on WhatsApp', 'Fale conosco pelo WhatsApp'],
    // /equipo/<slug>/ (tarjeta digital de una persona)
    ['Guardar contacto', 'Save contact', 'Salvar contato'],
    ['Se guarda en tu teléfono', 'Saved to your phone', 'Salvo no seu telefone'],
    ['Correo', 'Email', 'E-mail'],
    ['Calendario de Bison', 'Bison calendar', 'Calendário da Bison'],
    ['Más de Bison', 'More from Bison', 'Mais da Bison'],
    ['Agenda, rankings, blog y redes', 'Booking, rankings, blog and social', 'Agenda, rankings, blog e redes'],
    // /agenda (pantalla de paso al calendario)
    ['Abriendo la agenda…', 'Opening the calendar…', 'Abrindo a agenda…'],
    ['Si no se abre, haz clic aquí', 'If it does not open, click here', 'Se não abrir, clique aqui'],
  ].map(([es, en, pt]) => [es, [en, pt]])
);
